// eslint-disable-next-line no-restricted-imports
import { PeriodType as IPeriodtype } from '@eih-netbroker/api-order';

export const PeriodType = IPeriodtype;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PeriodType = (typeof PeriodType)[keyof typeof PeriodType];
